<template>
    <div class="w-100" style="overflow: auto;">
        <table class="table responsive table-bordered">
            <tbody>
            <tr>
                <th v-if="showIndicatorCode">{{t('indicatorCode')}}</th>
                <th class="col-1">
                    {{ showIndicatorCode ? t('doesDisaggregation') : t('shortDoesDisaggregation')}}
                </th>
                <th v-if="showDisaggregationType">{{t('disaggregationType')}}</th>
                <th v-if="showDisaggregation">{{t('disaggregation')}}</th>
                <th>{{t('year')}}</th>
                <th>{{t('unit')}}</th>
                <th>{{t('value')}}</th>
                <th>{{t('footnote')}}</th>
            </tr>
            <tr v-for="(unit, index) in indicatorData" :key="unit">
                
                <td  v-if="showIndicatorCode" :class="{'bg-danger' : !unit.indicatorCode || unit.indicatorCode != indicatorCode}">
                    {{unit.indicatorCode}}
                </td>
                <td>{{unit.hasDisaggregation ? t('yes') : t('no')}}</td>
                <th v-if="showDisaggregationType">{{unit.disaggregationType}}</th>
                <td v-if="showDisaggregation">{{unit.disaggregation}}</td>
                <td :class="{'bg-danger' : !isNumber(unit.year) || unit.year == 0}">
                    <label :for="`dataYear${index+1}`">
                        <span class="d-none">{{t('missingYear', {index:index+1})}}</span>
                    </label>
                    {{unit.year}}
                </td>
                <td :class="{'bg-danger' : !unit.unit}">
                    <label :for="`dataUnit${index+1}`">
                        <span class="d-none">{{t('missingUnit', {index:index+1})}}</span>
                    </label>
                    {{unit.unit}}
                </td>
                <td :class="{'bg-danger' : !isNumber(unit.value) || isNaN(unit.value)}">
                    <label :for="`dataValue${index+1}`">
                        <span class="d-none">{{t('missingValue', {index:index+1})}}</span>
                    </label>
                    {{unit.value}}
                </td>
                <td>{{unit.footnote}}</td>
            </tr>
        </tbody>
        </table>
    </div>
</template>
<i18n src="@/i18n/dist/components/pages/nr7/my-country/view/indicator-data-table.json"></i18n>

<script setup lang="ts">
import { computed, toRefs } from 'vue';
import type { ETerm } from '~/types/schemas/base/ETerm';
import { isNumber, isNaN } from 'lodash';
import { IndicatorsMappingData } from '~/app-data/indicators';

    const props = defineProps({
        indicatorData: { type: Object, required: true },
        indicatorCode: { type: String, required: true },
        showIndicatorCode: { type: Boolean, default:true }
    });

    const thesaurusStore    = useThesaurusStore();
    const {locale, t}       = useI18n();
    const { indicatorData } = toRefs(props);

    const indicator:ComputedRef<ETerm> = computed(() => thesaurusStore.getTerm(props.indicatorData?.indicator?.identifier));
    const showDisaggregation = computed(() => {
        return indicatorData.value?.some((unit:any) => {
            return unit.disaggregation;
        })
    }); 
    const showDisaggregationType = computed(() => {
        return indicatorData.value?.some((unit:any) => {
            return unit.disaggregationType;
        })
    }); 
    
    onMounted(async () => {
        if (indicatorData.value.indicator) {
            await thesaurusStore.loadTerm(indicatorData.value.indicator.identifier);
        }
    }); 
</script>

<style scoped></style>

